var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasHeader)?_c('div',[_c('md-card',{staticClass:"md-card-global-sales"},[_c('md-card-header',{class:_vm.getClass(_vm.headerColor)},[_vm._t("header")],2),_c('md-card-content',[_vm._t("content")],2)],1)],1):_c('div',[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }